/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, InputAdornment, Tooltip, IconButton } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import services from '../Service';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import SearchNotFound from '../../../SearchNotFound';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

var screenCode = "ADDEDSUPPLIERVIEW"
export default function SupplierView(props) {
  const navigate = useNavigate();
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: true,
    submitButtonName: 'Update',
    pageheadername: 'Added Suppliers View'
  });
  const [groupList, setGroupList] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [orderBreakdown, setOrderBreakdownList] = useState([]);
  const [orderBreakdownTotal, setOrderBreakdownTotal] = useState(0);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [date, setDate] = React.useState(new Date());
  const [isTable, setIsTable] = useState(false);
  const [formData, setFormData] = useState({
    groupID: 0,
    operationEntityID: 0,
    dataID: date.toISOString().split('T')[0],
    unitPrice: '250',
    date: date.toISOString().split('T')[0]
  });
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOrderBreakdownList([])
    setOpen2(false);
  };
  const useStyles = makeStyles({
    root: {
      width: '100%',
      overflowX: 'auto'
    },
  });

  const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
  });
  const classes = useStyles();

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(true);
    const classes = useRowStyles();

    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row" align='left'>{row.productName}</TableCell>
          <TableCell align="left">{row.productCode}</TableCell>
          <TableCell align="right">{parseFloat(row.quantity).toFixed(2)}</TableCell>
          <TableCell align="right">{parseFloat(row.acceptedQuantity).toFixed(2)}</TableCell>
          <TableCell align="right">{parseFloat(row.reaminingQuantity).toFixed(2)}</TableCell>
          <TableCell align="right">{parseFloat(row.returnQuantity).toFixed(2)}</TableCell>
          <TableCell align="center">
            <Tooltip title="More Details">
              <IconButton aria-label="delete"
                onClick={() => (viewFccOrderBreakdown(row))}
              >
                <MoreVertIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              {row.farmerModel.length != 0 ?
                <Box margin={1} marginLeft={17}>
                  <Typography variant="h7" gutterBottom component="div">
                    <b>Supplier Details</b>
                  </Typography>
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Supplier&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Crop</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>SKU</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Crop Variety</TableCell>
                        <TableCell align="right" style={{ fontWeight: 'bold' }}>Accepted Qty</TableCell>
                        <TableCell align="center" style={{ fontWeight: 'bold' }}>Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row.farmerModel.map((historyRow) => {
                        let GivenName = historyRow.givenName == null ? "" : historyRow.givenName
                        let Surname = historyRow.firstName == null ? "" : historyRow.firstName
                        let Nic = historyRow.nic == null ? "" : historyRow.nic
                        return (
                          <TableRow key={historyRow.performOrderFarmerMappingID}>
                            <TableCell align="left" component="th" scope="row">
                              {GivenName + ' ' + Surname + ' - ' + Nic}
                            </TableCell>
                            <TableCell align="left">{historyRow.productName}</TableCell>
                            <TableCell align="left">{historyRow.productCode}</TableCell>
                            <TableCell align="left">{historyRow.varietyName}</TableCell>
                            <TableCell align="right">{parseFloat(historyRow.acceptedQuantity).toFixed(2)}</TableCell>
                            <TableCell align="center">
                              {historyRow.statusID == 1 ?
                                <Chip label="Supplier Added" variant="outlined" color='success' />
                                : historyRow.statusID == 3 ? <Chip label="Processing" variant="outlined" color='success' />
                                  : historyRow.statusID == 5 ? <Chip label="Complete" variant="outlined" color='success' />
                                    : <Chip label="Ready To Weighment" variant="outlined" color='success' />}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </Box> : <Typography variant="h7" gutterBottom component="div">
                  <b>No Supplier Details</b>
                </Typography>}
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const priceOrderUpdateSearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center is required'),
    dateID: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      dateID: formData.dataID
    },

    validationSchema: priceOrderUpdateSearchSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm());
    }
  });

  async function SubmitForm() {
    setOrderDetails([]);
    var res = await services.GetVCCOrderDetails(formik.values.operationEntityID, formik.values.dateID);
    if (res != null) {
      res.sort((a, b) => a.productName > b.productName ? 1 : -1);
      setOrderDetails(res);
    }
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  async function clearAll() {
    setIsTable(false);
  }

  useEffect(() => {
    getPermissions();
  }, [])

  useEffect(() => {
    setIsTable(false);
  }, [formik.values.operationEntityID]);

  useEffect(() => {
    setIsTable(false);
  }, [formik.values.dateID]);

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    setOrderDetails([]);
  }, [formik.values.operationEntityID]);

  useEffect(() => {
    setOrderDetails([]);
  }, [formik.values.dateID]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWADDEDSUPPLIER');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
    trackPromise(GetAllGroups());
  }

  async function viewFccOrderBreakdown(data) {
    var res = await services.GetVCCOrderBreakdownDetailsByPerformOrderID(data.performOrderID);
    if (res.length > 0) {
      let total = 0;
      res.forEach(x => {
        total = total + x.quantity;
      });
      setOrderBreakdownList(res)
      setOrderBreakdownTotal(total)
      setOpen2(true)
    }
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  return (
    <>
      <LoadingComponent />
      <Page title="Added Suppliers View |  Agri-Connect">
        <Container maxWidth>
          <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center *"
                    value={formik.values.operationEntityID}
                    onChange={formik.handleChange}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Fresh Collection Center</MenuItem>
                    {operationEntityList.map((option) => (
                      option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    fullWidth
                    id="outlined-start-adornment"
                    size="small"
                    label="Date *"
                    type="Date"
                    value={formik.values.dateID}
                    onChange={formik.handleChange}
                    {...getFieldProps('dateID')}
                    error={Boolean(touched.dateID && errors.dateID)}
                    helperText={touched.dateID && errors.dateID}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>
                    }}
                  >
                  </TextField>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                      Clear
                    </Button>
                    <Button type="submit" color="secondary" variant="outlined">
                      Search
                    </Button>
                  </Stack>
                </Stack>
                <br />
                <>
                  {orderDetails.length != 0 ?
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Card style={{ justifycontent: 'center', width: '100%' }}>
                        <Paper className={classes.root}>
                          <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                              <TableHead>
                                <TableRow>
                                  <TableCell />
                                  <TableCell style={{ fontWeight: 'bold' }} align='left'>Crop</TableCell>
                                  <TableCell align="left" style={{ fontWeight: 'bold' }}>SKU</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Requested Qty</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Accepted Qty</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Remaining Qty</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Return Qty</TableCell>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody >
                                {orderDetails.map((row) => (
                                  <Row key={row.performOrderID} row={row} />
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Paper>
                      </Card>
                    </Stack> : <SearchNotFound searchQuery="Added Suppliers" />}
                </>
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
        <Dialog open={open2} onClose={handleClose2} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Order Breakdown</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }} align="left">Crop</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }} align="left">SKU</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }} align="right">Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderBreakdown.map((row) => (
                    <TableRow>
                      <TableCell align="left">
                        {row.outletOrderProductName}
                      </TableCell>
                      <TableCell align="left">{row.outletOrderProductCode}</TableCell>
                      <TableCell align="right">{parseFloat(row.quantity).toFixed(2)}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }} align="left" colSpan={2}>
                      Total
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }} align="right">{parseFloat(orderBreakdownTotal).toFixed(2)}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose2} color="secondary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Page>
    </>
  );
}
